<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1 class="toc-title"><a id="page-xi"></a>Contents</h1>
<ol class="none" epub:type="list">
<li class="toc-front" id="cover"><span href="#/cover" title="Link target outside of Sample">Cover</span></li>
<li class="toc-front" id="titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li class="toc-front" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></li>
<li class="toc-part" id="toc-part001"><a href="#/part001">Book I: O Canada</a>
<ol class="none">
<li class="toc-chapter" id="toc-chapter001"><a href="#/chapter001">One</a></li>
<li class="toc-chapter" id="toc-chapter002"><a href="#/chapter002">Two</a></li>
<li class="toc-chapter" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">Three</span></li>
</ol></li>
<li class="toc-part" id="toc-part002"><span href="#/part002" title="Link target outside of Sample">Book II: Pay the Piper</span>
<ol class="none">
<li class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">One</span></li>
<li class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">Two</span></li>
<li class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">Three</span></li>
</ol></li>
<li class="toc-part" id="toc-part003"><span href="#/part003" title="Link target outside of Sample">Book III: Should Auld Acquaintance Be Forgot</span>
<ol class="none">
<li class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">One</span></li>
<li class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">Two</span></li>
<li class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">Three</span></li>
<li class="toc-chapter" id="toc-chapter009a"><span href="#/chapter009a" title="Link target outside of Sample">Four</span></li></ol></li>
<li class="toc-part" id="toc-part004"><span href="#/part004" title="Link target outside of Sample">Book IV: Enemy Without, Enemy Within</span>
<ol class="none">
<li class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">One</span></li>
<li class="toc-chapter" id="toc-chapter011"><span href="#/chapter011" title="Link target outside of Sample">Two</span></li>
<li class="toc-chapter" id="toc-chapter012"><span href="#/chapter012" title="Link target outside of Sample">Three</span></li></ol></li>
<li class="toc-part" id="toc-part005"><span href="#/part005" title="Link target outside of Sample">Book V: The Gang’s All Here</span>
<ol class="none">
<li class="toc-chapter" id="toc-chapter013"><span href="#/chapter013" title="Link target outside of Sample">One</span></li>
<li class="toc-chapter" id="toc-chapter014"><span href="#/chapter014" title="Link target outside of Sample">Two</span></li>
<li class="toc-chapter" id="toc-chapter015"><span href="#/chapter015" title="Link target outside of Sample">Three</span></li>
<li class="toc-chapter" id="toc-chapter016"><span href="#/chapter016" title="Link target outside of Sample">Four</span></li>
<li class="toc-chapter" id="toc-chapter017"><span href="#/chapter017" title="Link target outside of Sample">Five</span></li></ol></li>
<li class="toc-chapter1" id="Ref_82016a"><span href="#/appendix002" title="Link target outside of Sample">Extras</span>
<ol class="none">
<li class="toc-chapter" id="toc-personblurb"><span href="#/personblurb" title="Link target outside of Sample">Meet the Author</span></li>
<li class="toc-chapter" id="toc-ad-card"><a href="#/adcard">By Mira Grant</a></li>
<li class="toc-chapter" id="toc-teaser001"><span href="#/teaser001" title="Link target outside of Sample">A Preview of <em>Into the Drowning Deep</em></span></li></ol></li>
<li class="toc-appendix" id="toc-appendix001"><span href="#/appendix001" title="Link target outside of Sample">About Orbit Short Fiction</span></li>
<li class="toc-appendix" id="Newsletters"><span href="#/newsletterOrbit" title="Link target outside of Sample">Orbit Newsletter</span></li>
</ol>
</nav>
<nav class="hidden-tag" epub:type="landmarks" hidden="hidden">
<h1>Navigation</h1>
<ol class="none" epub:type="list">
<li><a epub:type="bodymatter" href="#/chapter001">Begin Reading</a></li>
<li><a epub:type="toc" href="#/toc">Table of Contents</a></li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?69ce3b1a